export const ELIGIBILITY_TYPE = {
    ALLOWED_PAYMENT_METHODS: 'ALLOWED_PAYMENT_METHODS',
    AUTOPAY: 'AUTOPAY',
    ONE_TIME_PAYMENT: 'ONE_TIME_PAYMENT',
    PAYMENT_OPTION: 'PAYMENT_OPTION',
    REPAYABLE_AMOUNT: 'REPAYABLE_AMOUNT'
};
